module.exports = __webpack_public_path__ + "img/QIWI.33a294e9.svg";